import { createFileRoute } from '@tanstack/react-router'

import PointsPage from '@/views/loyalty/points/pages/points.page'

export const Route = createFileRoute('/_layout/loyalty/points')({
  component: PointsPage,
})
